import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import MuiDialogContent from '@mui/material/DialogContent';
/**
 * A simple wrapper for the content of the Modal.
 */
export const ModalContent = ({ children }) => {
    return _jsx(MuiDialogContent, { sx: { paddingX: 0, paddingY: 2 }, children: children });
};
